

/*
 * 採用情報 活躍職種用
 */
if($('.skill-header').length == 0) {
  jQuery(function () {
    $('.add').on('click', function () {
      var clone = $(this).parent().parent().clone(true);
      clone.find("input[type='text']").val("");
      clone.insertAfter($(this).parent().parent());
    });
    $('.del').on('click', function () {
      var target = $(this).parent().parent();
      if (target.parent().children().length > 1) {
        target.remove();
      }
    });
    if ($('.replicate-recruit').length) {
      $('.replicate-recruit').on('click', function () {
        if (!confirm('前年度の採用情報をコピーします。よろしいですか？※コピーできるのは一度限りですのでご注意ください。')) {
          return false;
        }
        return true;
      });
    }
  });
}
